<mat-form-field class="serviw-field-filter">
    <button mat-button *ngIf="value" matPrefix mat-icon-button aria-label="Clear" (click)="reset()">
        <mat-icon>close</mat-icon>
    </button>

    <input matInput class="serviw-filter-input" autocomplete="off" (keyup)="onkeyup($event)"
        (keydown)="handleKeydown($event)" (focus)="setFilter(true)" (blur)="setFilter(false)" placeholder="Buscar"
        [value]="value" />
</mat-form-field>